var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-dark"},[_c('div',{staticClass:"block no-internet"},[_c('div',{staticClass:"wrong_rotate__img"}),_vm._v(" "),_c('h2',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t("translation.rotateYourDevice")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0a46c9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-up/RotatePhone.vue
// module id = null
// module chunks = 